export default "__VITE_ASSET__B5K8FXjg__"